import { useCallback, useEffect } from "react";
import { useHistory } from "react-router";

import { Grid } from "@material-ui/core";
import { useSessaoAtual } from "services/app/providers";
import { CircularLoading } from "views";
import { useToastSaurus } from "services/app";
import { makeUtilClasses } from '../../../theme/util-make-styles';


const LogoutPage = () => {
    const { replace: historyReplace } = useHistory();
    const { deslogar, usuario } = useSessaoAtual();
    const utilClasses = makeUtilClasses();
    const { showToast } = useToastSaurus();

    const efetuarLogout = useCallback(() => {
        try {
            deslogar(usuario?.usuarioId || '');
        } catch (e: any) {
            showToast("error", e.message);
        }
        historyReplace("/login");
    }, [deslogar, historyReplace, showToast, usuario?.usuarioId]);

    useEffect(() => {
        efetuarLogout();
    }, [efetuarLogout]);

    return (
        <>
            <div className={utilClasses.contentCenter}>
                <Grid container className={utilClasses.rootContainer}>
                    <CircularLoading tipo="FULLSIZED" />
                </Grid>
            </div>
        </>
    )
}

export default LogoutPage;


